import { Button } from "@hortis/ui/button";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@hortis/ui/form";
import { ChevronDown } from "@hortis/ui/icons";
import { useFormContext } from "react-hook-form";
import { FieldsHeader } from "src/components/forms/fields-header";
import {
  LocationPicker,
  LocationPickerLabel,
} from "src/features/locations/components/location-picker";
import { MaterialMapPositionField } from "../map-position-field/map-position-field";

interface PositionFieldsProps {
  namePrefix: string;
  hideMap?: boolean;
}

export const PositionFields = ({
  namePrefix,
  hideMap,
}: PositionFieldsProps) => {
  const form = useFormContext();
  return (
    <FieldsHeader
      header="Location"
      buttonTestId="add-position-button"
      testId="location-header"
    >
      <div className="flex flex-col gap-6 pt-6">
        <FormField
          control={form.control}
          name={`${namePrefix}collectionSiteLocationOption`}
          render={({ field }) => (
            <FormItem>
              <FormLabel required>Location</FormLabel>
              <FormControl>
                <LocationPicker
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- no form typesafety yet
                  value={field.value}
                  onChange={field.onChange}
                  data-cy="location"
                >
                  <Button
                    className="min-h-[44px] justify-between px-[14px]! py-2! text-grey-500"
                    endIcon={ChevronDown}
                  >
                    {field.value == null ? (
                      "Select location..."
                    ) : (
                      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- no form typesafety yet
                      <LocationPickerLabel value={field.value} />
                    )}
                  </Button>
                </LocationPicker>
              </FormControl>
              <FormMessage data-cy="form-error" />
            </FormItem>
          )}
        />
        {hideMap !== true && (
          <FormField
            control={form.control}
            name={`${namePrefix}position`}
            render={({ field }) => (
              <FormItem>
                <FormLabel>Map position</FormLabel>
                <FormControl>
                  <MaterialMapPositionField
                    {...field}
                    trigger={() => form.trigger(field.name)}
                  />
                </FormControl>
                <FormMessage data-cy="form-error" />
              </FormItem>
            )}
          />
        )}
      </div>
    </FieldsHeader>
  );
};
